module.exports = __webpack_public_path__ + "media/creativeMedia/panel-1.1Landscape-bf91d9c1.png";